/** @jsx jsx */
import { jsx, Container, Text, Box } from 'theme-ui'
import { FC } from 'react'
import { space } from '~/gatsby-plugin-theme-ui'
import HeadingV2 from '~/componentsV2/heading'
import {
  DynamicBreadcrumbs,
  useDynamicCollectionMenus,
} from '~/containers/product-detail-v2/bespoke-detail/menus'

type Props = {
  title: string
  description?: string
}

const textToRemoval = [' | Ben Soleimani', ' - Shop All']
const removeText = (title: string) => {
  textToRemoval.forEach(text => {
    title = title.replace(text, '').split('|')[0].trim()
  })
  return title
}

const SimpleContent: FC<Props> = ({ title, description }) => {
  return (
    <Container sx={{ px: 16, pt: ['16px', space.md3] }}>
      <DynamicBreadcrumbs />
      <HeadingV2
        level="1"
        className="simple-content__title"
        sx={{
          textAlign: 'initial',
          mb: description ? [space.sm, space.md1] : 0,
          pt: 4,
          textTransform: 'uppercase',
          fontSize: '2rem !important',
        }}
      >
        {removeText(title)}
      </HeadingV2>
      {description && (
        <Box sx={{ pt: space.sm, width: ['100%', null, '70%', '50%'] }}>
          <Text sx={{ fontSize: '16px !important' }}>{description}</Text> /
        </Box>
      )}
    </Container>
  ) as JSX.Element
}

export default SimpleContent
